// 菜单翻译文件 - 更新时间戳 - 修复个人设置菜单显示问题 - 强制刷新缓存
import defaultProcessMenu from './menu.default';
import kdProcessMenu from './menu.kd';

const customerOverrides: Record<string, Record<string, string>> = {
  kd: kdProcessMenu,
};

const CUSTOMER: string = process.env.CUSTOMER || 'default';

export default {
  'menu.welcome': '欢迎',
  'menu.overview': '项目概览',
  'menu.project-settings': '项目设置',
  'menu.project-info': '项目信息',
  'menu.process-config': '过程配置',
  'menu.team-management': '团队管理',
  'menu.dev-repository': '开发库',
  'menu.recycle-bin': '回收站',
  'menu.work-products': '工作成果',
  'menu.review-tasks': '评审任务',
  'menu.system-overview': '系统概览',
  'menu.user-list': '用户列表',
  'menu.project-list': '项目列表',
  'menu.system-settings': '系统设置',
  'menu.personal-settings': '个人设置',
  'menu.account-info': '账号信息',
  'menu.notifications': '消息通知',
  'menu.process-docs-preview': '程序文件预览',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',

  // ASPICE专员界面菜单
  'menu.aspice.overview': '系统概览',
  'menu.aspice.projects': '项目列表',
  'menu.aspice.templates': '模板列表',
  'menu.aspice.roles': '角色列表',
  'menu.aspice.processdocs': '程序文件',
  'menu.aspice.backToNormal': '返回开发页面',

  // ASPICE 过程名称 - 工作成果菜单（由客户配置覆盖，通过 CUSTOMER 环境变量控制）
  ...defaultProcessMenu,
  ...(customerOverrides[CUSTOMER] || {}),
};
